import React from "react";

import { css } from "@emotion/core";

import { Price, Currency } from "@zapier/currency";
import { Border, Colors } from "@zapier/checkout/esm/constants";
import { useTheme, Colors as ThemeColors } from "@zapier/design-system";
import { tableItem } from "../ChangePlanSummary";

type AmountDueProps = {
  amountDue: number;
  currency?: Currency;
};

const invoiceTotalCss = css`
  color: ${Colors.deepSpace};
  display: flex;
  font-weight: 600;
  padding: 10px;

  &:not(:last-child) {
    border-bottom: ${Border.size.default} solid ${Border.color.default};
  }
`;

const invoiceTotalPriceCss = css`
  font-size: 1.3em;
  margin-left: auto; /* push the price to the right of the container */
  white-space: nowrap;
  padding-left: 20px;
`;

const rebrandInvoiceTotalCss = css`
  padding: 0;
  &:not(:last-child) {
    border-bottom: 1px solid ${ThemeColors.neutral400};
  }
`;

const rebrandInvoiceTotalPriceCss = css`
  margin-left: inherit;
  font-size: 1em;
  white-space: inherit;
`;

export const AmountDue = ({ amountDue, currency }: AmountDueProps) => {
  const { isRebrand } = useTheme();
  // for the Backend, a negative price means a refund...
  const isRefund = amountDue < 0;

  return (
    <div
      css={[
        invoiceTotalCss,
        isRebrand && tableItem,
        isRebrand && rebrandInvoiceTotalCss,
      ]}
    >
      <span>
        {isRefund
          ? "Credit applied to your next invoice"
          : "Amount charged today"}
      </span>
      <span
        css={[invoiceTotalPriceCss, isRebrand && rebrandInvoiceTotalPriceCss]}
      >
        <Price currency={currency} isLocalized={true}>
          {Math.abs(amountDue)}
        </Price>
      </span>
    </div>
  );
};
